export const HEADINGS = [
  ["created_at", "Date"],
  ["transaction_id", "Transaction ID"],
  ["transaction_note", "Description"],
  ["transaction_type", "Type"],
  ["transaction_value", "Amount"],
];
